import { baseService } from "../base";
import type {
  AddOnServiceDto,
  CreateAddOnServiceDto,
  UpdateAddOnServiceDto,
  GetAddOnServicesDto,
} from "./add-on-services.types";

const BASE_URL = "/add-on-services";

export const addOnServicesApi = {
  // Get all add-on services
  getAll: async (params?: GetAddOnServicesDto): Promise<AddOnServiceDto[]> => {
    const response = await baseService.get(BASE_URL, { params });
    return response.data;
  },

  // Get add-on service by ID
  getById: async (id: string): Promise<AddOnServiceDto> => {
    const response = await baseService.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Get add-on services by type
  getByType: async (type: string): Promise<AddOnServiceDto[]> => {
    const response = await baseService.get(`${BASE_URL}/type/${type}`);
    return response.data;
  },

  // Create new add-on service
  create: async (data: CreateAddOnServiceDto): Promise<AddOnServiceDto> => {
    const response = await baseService.post(BASE_URL, data);
    return response.data;
  },

  // Update add-on service
  update: async (
    id: string,
    data: UpdateAddOnServiceDto
  ): Promise<AddOnServiceDto> => {
    const response = await baseService.patch(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  // Delete add-on service
  delete: async (id: string): Promise<void> => {
    await baseService.delete(`${BASE_URL}/${id}`);
  },
};
